import { logger } from "../core/logger";
import { AxiosError, AxiosResponse } from "axios";
import * as env from "../environments/config";
import { createServiceCoordinator } from "zeus-front-utils";
import { RequestType } from "src/types/requests";

interface LoginData {
  password: string;
  username: string;
}

export const serviceLogin = async <T>(request: RequestType) => {
  try {
    const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};
    const { SCKey } = (cfg || {}) as { SCKey?: string };
    return createServiceCoordinator({ publicKey: SCKey })(request) as Promise<
      AxiosResponse<T, any>
    >;
  } catch (e) {
    console.error("service - error getting session data:", e);
    throw new Error("No keys founded");
  }
};

export const authLogin = async (payload: LoginData) => {
  const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};
  const { API_LOGIN } = (cfg || {}) as { API_LOGIN?: string };

  if (!API_LOGIN) return;
  const { username, password } = payload;
  const body = {
    username,
    password,
  };

  const request = {
    url: API_LOGIN,
    method: "post" as const,
    body,
    Headers: { "Content-Type": "application/json" },
    requestConfig: {
      encryptedBody: ["username", "password"],
    },
    responseConfig: {
      encryptedResponse: [
        "auth.accessToken",
        "auth.username",
        "auth.idToken",
        "auth.refreshToken",
        "auth.company.companyEmail",
        "auth.company.id_company",
        "auth.company.photo",
      ],
    },
  };

  try {
    const res = await serviceLogin(request);
    return res?.data ?? res;
  } catch (err: any) {
    if (err instanceof AxiosError) {
      logger.error("Error en Login (AxiosError):", err.response?.data ?? err.message);
      return err.response?.data ?? err.response ?? err;
    }
    logger.error("Error en Login:", err);
    return err;
  }
};
